// filters an ordered list of strings values out of an
//      ordered list of string values in O(n)
// requires every value in toRemove to be in orig and
//    and for both lists to be sets
export const filterSortedList = (orig, toRemove) => {
  let i = 0;
  return orig.reduce((ret, x) => {
    if (x === toRemove[i]) {
      i++;
      return ret;
    }
    return [...ret, x];
  }, []);
};

// insert a value into an ordered list of values without allowing duplicates
export const insertSortedSet = (arr, el) => {
  let ret = arr;
  if (el.localeCompare(arr[0]) === -1) {
    ret = [el, ...arr];
  }
  for (let i = 0; i < arr.length; i++) {
    const cmp = el.localeCompare(arr[i]);
    if (cmp === 1) {
      ret = [...arr.slice(0, i + 1), el, ...arr.slice(i + 1)];
    } else if (cmp === 0) {
      return arr;
    }
  }
  return ret;
};

// converts list of numbers to list of continuous ranges
export const convertToRanges = (nums) => {
  const ranges = [[nums[0], nums[0]]];
  let j = 0;

  for (let i = 1; i < nums.length; i++) {
    if (nums[i] - ranges[j][1] === 1) {
      ranges[j][1] = nums[i];
    } else {
      ranges[++j] = [nums[i], nums[i]];
    }
  }
  return ranges
    .map(([start, end]) => (start !== end ? `${start}-${end}` : `${start}`))
    .join(", ");
};

const wellToNum = (well) =>
  (well.charCodeAt(0) - 64) * 100 + parseInt(well.substring(1));

const numToWell = (num) => {
  const row = Math.floor(num / 100);
  const col = num % 100;
  if (col < 10) {
    return String.fromCharCode(row + 64) + "0" + col;
  }
  return String.fromCharCode(row + 64) + col;
};

export const convertWellsToRanges = (wells) => {
  const nums = wells.map(wellToNum);
  const ranges = [[nums[0], nums[0]]];
  let j = 0;

  for (let i = 1; i < nums.length; i++) {
    if (nums[i] - ranges[j][1] === 1) {
      ranges[j][1] = nums[i];
    } else {
      ranges[++j] = [nums[i], nums[i]];
    }
  }
  return ranges
    .map(([start, end]) =>
      start !== end
        ? `${numToWell(start)}-${numToWell(end)}`
        : `${numToWell(start)}`
    )
    .join(", ");
};

export const addDefaultOpt = (obj) => [
  {
    value: "",
    label: "",
  },
  ...obj,
];

export const getVectorTypeGivenRegion = (region) => {
  return region?.startsWith("moz") || region?.startsWith("mos")
    ? "mosquito"
    : region?.startsWith("tick")
    ? "tick"
    : "";
};

// The vector type of the tray on display, for anything that has to match how
// it was classified: the species list, trap types and the fallback confidence
// threshold. A tray records it at capture - algVectorType is the model family
// the alg service ran, vectorType the family the device was set to - and that
// beats any device's current setting, which may have changed since, and which
// belongs to another device altogether when the tray is opened from All
// Devices or by its URL. A tray that recorded neither (a capture still in
// progress, or one from before they were recorded) falls back to its own
// device's setting, then to the selected device's.
export const getTrayVectorType = (state) => {
  const tray = state?.capture?.tray;
  const recorded = [tray?.algVectorType, tray?.vectorType]
    .map(getVectorTypeGivenRegion)
    .find(Boolean);
  if (recorded) {
    return recorded;
  }
  const { selectedDevice, ...devices } = state?.devices || {};
  return (
    devices?.[tray?.device]?.vectorType || devices?.[selectedDevice]?.vectorType
  );
};

export const caseInsensitiveIteree = (key) => (item) =>
  Array.isArray(item?.[key]) &&
  item[key].every((x) => typeof x === "string" || x instanceof String)
    ? item[key].sort().join(", ").toLowerCase()
    : typeof item?.[key] === "string" || item?.[key] instanceof String
    ? item[key].toLowerCase()
    : item?.[key];

